import React, { Component } from 'react'
import { connect } from 'react-redux'
import { 
	closeModal, 
	deleteItem,
	saveUser,
	openModal,
	cancelPremium
} from 'state/actions'

import { 
	getCurrentUser,
	getCurrentAccount,
	getProjectSelector
} from 'state/selectors'

import { withRouter } from 'react-router'

import { CSSTransitionGroup } from 'react-transition-group'

import Loader from 'components/loader/loader'

import CloseModal from './modal-components/close-modal'

import ModalDelete from './modal-types/modal-delete'
import ModalRestore from './modal-types/modal-restore'
import ModalLeave from './modal-types/modal-leave'
import ModalProject from './modal-types/modal-project'
import ModalFolder from './modal-types/modal-folder'
import ModalMilestone from './modal-types/modal-milestone'
import ModalInvite from './modal-types/modal-invite'
import ModalSettings from './modal-types/modal-settings'
import ModalOrganisations from './modal-types/modal-organisations'
import ModalUpload from './modal-types/modal-upload'
import ModalPendingInvitation from './modal-types/modal-pending-invitation'
import ModalError from './modal-types/modal-error'
import ModalAnnouncement from './modal-types/modal-announcement'
import ModalTaskName from './modal-types/modal-task-name'
import ModalPreview from './modal-types/modal-preview'
import ModalTeam from './modal-types/modal-team'
import ModalAssignProjects from './modal-types/modal-assign-projects'
import ModalConfirm from './modal-types/modal-confirm'
import ModalFeedback from './modal-types/modal-feedback'
import ModalProgressUpdate from './modal-types/modal-progress-update'
import ModalEvent from './modal-types/modal-event'
import ModalStakeholder from './modal-types/modal-stakeholder'
import ModalDismiss from './modal-types/modal-dismiss'
import ModalUpgrade from './modal-types/modal-upgrade'
import ModalRecur from './modal-types/modal-recur'
import ModalPlans from './modal-types/modal-plans'
import ModalWelcomeBusiness from './modal-types/modal-welcome-business'
import ModalFileInfo from './modal-types/modal-file-info'
import ModalTrialOver from './modal-types/modal-trial-over'
import ModalAddTime from './modal-types/modal-add-time'
import ModalWellness from './modal-types/modal-wellness'
import ModalCloseAccount from './modal-types/modal-close-account'
import ModalRegister from './modal-types/modal-register'
import ModalCustomiseProject from './modal-types/modal-customise-project'

import { disableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock'

import { 
	isBlockedPremiumAccount
} from 'utils'

class Modal extends Component {
	state = {
		isLoading: false,
		currentOpenMenu: null,
		scrollbarWidth: null
	}

	openMenu = type => {
		this.setState({
			currentOpenMenu: type
		})
	}

	dismissDatepicker = _ => {
		this.setState({
			currentOpenMenu: null
		})
	}

	closeModal = _ => {		
		if(this.props.modal.operation !== "not-ready"){
			clearAllBodyScrollLocks()

			this.props.closeModal()
		}
	}

	simulateUnmount = _ => {
		clearAllBodyScrollLocks()

		setTimeout(_ => {
			this.setState({
				scrollbarWidth: null
			})
		})
		
		this.setLoading(false)

		setTimeout(_ => {
			const {
				accountData,
				openModal,
				cancelPremium,
				modal
			} = this.props

			if(!modal.operation && isBlockedPremiumAccount(accountData)){
				openModal('trial-over','trial-over')
			}
		},300)
	}

	UNSAFE_componentWillUpdate = nextProps => {
		const {
			modal
		} = this.props

		if(modal.operation && !nextProps.modal.operation){
			this.simulateUnmount()
		}else if(!modal.operation && nextProps.modal.operation){
			// opening a new modal
			const element = document.getElementById('modal-preview')
			
			disableBodyScroll(element, {
				reserveScrollBarGap: true
			})
		}
	}

	setLoading = isLoading => {
		this.setState({
			isLoading
		})
	}

	render() {
		const {
			modal,
			userData,
			saveUser,
			currentProject,
			currentAccount,
		} = this.props

		const {
			data,
			dataType,
			operation
		} = modal

		const modalData = data

		const {
			isLoading,
			scrollbarWidth
		} = this.state

		let modalTitle = ''
		let component = null
		let className = ''
		let isTall = false
		let hideDarkBg = false

		let dataTypeName = dataType

		switch(dataType){
			case 'bulletin':
				dataTypeName = 'announcement'
				break
			case 'checklist_item':
				dataTypeName = 'checklist item'
				break
			case 'file_folder':
				dataTypeName = 'file folder'
				break
			default:
				dataTypeName = dataType
				break
		}

		if(operation){
			if(operation === 'delete'){
				let isArchived = false 

				switch(dataType){
					case 'task':
					case 'milestone':
					case 'project':
						if(modalData.data && !modalData.data.deleted_at){
							isArchived = true

							if(dataType == 'milestone' && modalData.isShowingArchived){
								isArchived = false
							}
						}
						break
				}
				
				if(dataType === 'archived'){
					// to clear ALL archived tasks
					modalTitle = 'Delete all archived tasks?'
				}else{
					let action = 'Delete'

					if(isArchived){
						action = 'Archive'
					}

					if(modalData.leaveOnly){
						action = 'Leave'
					}
					
					modalTitle = `${ action } this ${ dataTypeName }?`
				}

				component = <ModalDelete 
					isArchived={isArchived} 
					setLoading={this.setLoading} 
					currentProject={currentProject} 
					currentAccount={currentAccount} 
					closeCallback={this.closeModal} 
					data={modalData} 
					dataType={dataType} 
				/>
			} else{
				let skipDataTypeSwitch = false

				let modalProps = {
					isLoading,
					setLoading: this.setLoading,
					closeCallback: this.closeModal,
					data: modalData,
					openMenuCallback: this.openMenu,
					modalState: this.state,
					operation: operation,
					dataType
				}

				switch(operation){
					case 'edit':
						if(modalData.duplicate){
							modalTitle = 'Duplicate ' + dataTypeName
						}else{
							modalTitle = 'Edit ' + dataTypeName
						}
						break
					case 'invite':
						const isGuest = modal.data && modal.data.type && modal.data.type == 'guest'

						modalTitle = `Invite ${isGuest ? 'guests' : 'team members'}`
						break
					case 'upload':
						modalTitle = modalData.chat ? 'Upload files to chat' : 'Upload files'
						break
					case 'accept':
						modalTitle = 'Accept this invitation?'
						break
					case 'error':
						modalTitle = 'Ah, jeez.'
						break
					case 'swap':
						modalTitle = 'My organizations'
						break
					case 'leave':
						modalTitle = 'Leave this organization?'
						break
					case 'preview':
					case 'assign':
					case 'set':
					case 'feedback':
						modalTitle = null
						break
					case 'confirm':
						modalTitle = 'Success!'

						if(modalProps){
							if(modalProps.data.isError){
								modalTitle = "Ah, jeez."
							}else if(modalProps.data.title){
								modalTitle = modalProps.data.title
							}
						}
						break
					case 'close':
						modalTitle = `Close this account?`
						component = <ModalCloseAccount {...modalProps} closeCallback={this.closeModal} data={modalData}  />
						skipDataTypeSwitch = true
						break
					case 'announcement':
						modalTitle = "What's new with Hassl?"	
						component = <ModalAnnouncement closeCallback={this.closeModal} userData={userData} data={modalData} />
						skipDataTypeSwitch = true
						break
					case 'restore':
						modalTitle = `Restore this ${dataType}?`	
						component = <ModalRestore {...modalProps} />
						skipDataTypeSwitch = true
						break
					case 'add':
						if(dataType == 'stakeholder'){
							modalTitle = 'Add a stakeholder'
						}else{
							modalTitle = 'Add a progress update'
						}
						break
					case 'view':
						modalTitle = 'View progress update'
						break
					case 'dismiss':
						modalTitle = 'Dismiss task'
						component = <ModalDismiss {...modalProps} userData={userData}/>
						skipDataTypeSwitch = true
						break
					case 'recur':
						modalTitle = 'Recurring task'
						component = <ModalRecur {...modalProps} userData={userData} />
						skipDataTypeSwitch = true
						break
					case 'upgrade':
						modalTitle = null
						skipDataTypeSwitch = true
						component = <ModalUpgrade {...modalProps} />
						break
					case 'duplicate':
						modalTitle = `Duplicate ${dataTypeName}`
						break
					case 'file_folder':
						modalTitle = 'Create a new file folder'
						break
					case 'welcome':
						modalTitle = null
						skipDataTypeSwitch = true
						component = <ModalWelcomeBusiness {...modalProps} />
						break
					case 'inspect':
						modalTitle = null
						skipDataTypeSwitch = true
						component = <ModalFileInfo {...modalProps} />
						break
					case 'trial-over':
						modalTitle = null
						skipDataTypeSwitch = true
						component = <ModalTrialOver {...modalProps} />
						break
					case 'add-time':
						modalTitle = null
						skipDataTypeSwitch = true
						component = <ModalAddTime {...modalProps} />
						break
					case 'wellness':
						modalTitle = null
						skipDataTypeSwitch = true
						component = <ModalWellness {...modalProps} />
						break
					case 'register':
						modalTitle = null
						skipDataTypeSwitch = true
						component = <ModalRegister {...modalProps} />
						hideDarkBg = !modalData || !modalData.isSecondaryAccount
						break
					case 'customise':
						skipDataTypeSwitch = true
						component = <ModalCustomiseProject {...modalProps} />
						break
					case 'create':
					default:
						modalTitle = 'Create a new '+dataTypeName+''
						break
				}

				if(!skipDataTypeSwitch){
					switch(dataType){
						case 'project':
							component = <ModalProject dismissDatepicker={this.dismissDatepicker} {...modalProps} />
							modalTitle = null
							break
						case 'folder':
						case 'file_folder':
							// Todo: maybe combine this with newGroup? Almost identical.
							component = <ModalFolder  {...modalProps} />;
							break
						case 'milestone':
							component = <ModalMilestone  {...modalProps} />;
							break
						case 'invite':
							component = <ModalInvite  {...modalProps} />;
							break
						case 'pending_invitation':
							component = <ModalPendingInvitation  {...modalProps}  />;
							break
						case 'settings':
							modalTitle = null
							component = <ModalSettings {...modalProps}  />;
							break
						case 'file':
						case 'task_file':
							component = <ModalUpload {...modalProps} />;
							break
						case 'organisation':
							if(operation == 'leave'){
								component = <ModalLeave {...modalProps} />
							}else{
								component = <ModalOrganisations {...modalProps} />	
							}
							break
						case 'task':
							component = <ModalTaskName {...modalProps} />
							break
						case 'files':
							component = <ModalPreview {...modalProps} />
							break
						case 'team':	
							component = <ModalTeam {...modalProps} />
							break
						case 'assign-projects':
							component = <ModalAssignProjects {...modalProps} />
							break
						case 'confirm':
							component = <ModalConfirm {...modalProps} />
							break
						case 'feedback':
							modalTitle = null
							component = <ModalFeedback {...modalProps} />
							break
						case 'update':
							component = <ModalProgressUpdate {...modalProps} />
							break
						case 'event':
							modalTitle = null
							component = <ModalEvent {...modalProps} />
							break
						case 'stakeholder':
							component = <ModalStakeholder {...modalProps} />
							isTall = true
							break
						case 'pricing':
							modalTitle = null
							component = <ModalPlans {...modalProps} />
							break
						case null:
							component = <ModalError {...modalProps} />
							break
						default:
							break
					}
				}
			}

			className = 'clear '+operation+'-'+dataType

			if(isLoading){
				className += ' loading'
			}

			if(isTall){
				className += ' tall'
			}
		}

		return(
			<span className={`modal-container ${ hideDarkBg ? 'hide-dark-bg' : ''}`}>
				<CSSTransitionGroup 
					transitionName="modal" 
					transitionEnterTimeout={1} 
					transitionLeaveTimeout={200}
				>
					{
						modal.operation ? 
						<x-modal 
							onClick={this.closeModal} 
							key={modal.operation} 
							id="modal" 
							style={{
								paddingRight: scrollbarWidth
							}}
						>
							<div 
								className={className} 
								onClick={e => {	
									e.stopPropagation()
									this.dismissDatepicker()}
								}
							>
								<CloseModal closeCallback={this.closeModal} />
								<Loader visible={isLoading} />
								{
									modalTitle ?
									<h2>
										{ modalTitle }
									</h2>
									: null
								}
								{component}
							</div>
						</x-modal>
						: null
					}
				</CSSTransitionGroup>
			</span>
		);
	}
}

function mapStateToProps(state, props){
	return {
		currentProject: getProjectSelector(state, props),
		userData: getCurrentUser(state),
		modal: state.modal,
		accountData: getCurrentAccount(state),
	}
}

export default withRouter(connect(mapStateToProps, {
	closeModal,
	deleteItem,
	saveUser,
	openModal,
	cancelPremium
})(Modal))